import { orderServices } from '../../services/trading-services';

export const orderActions = {
    getOrderBookAction,
    placeOrderAction,
    cancelOrderAction,
    modifyOrderAction,
    getOrderDetailAction,
    getOrderFeesAction
}

function getOrderBookAction(params, callback) {
    return () => {
        orderServices.getOrderBookService(params, res => {
            callback(res)
        })
    }
}

function placeOrderAction(params, callback) {
    return () => {
        orderServices.placeOrderService(params, res => {
            callback(res)
        })
    }
}

function cancelOrderAction(params, callback) {
    return () => {
        orderServices.cancelOrderService(params, res => {
            callback(res)
        })
    }
}

function modifyOrderAction(params, callback) {
    return () => {
        orderServices.modifyOrderService(params, res => {
            callback(res)
        })
    }
}

function getOrderDetailAction(params, callback) {
    return () => {
        orderServices.getOrderDetailService(params, res => {
            callback(res)
        })
    }
}

function getOrderFeesAction(params, callback) {
    return () => {
        orderServices.getOrderFeesService(params, res => {
            callback(res)
        })
    }
}